import * as actionTypes from '../actions/actionTypes'
import { updateObject } from '../../shared/utility'

const initialState = {
    ingredients: null,
    totalPrice: 4,
    error: false,
    building: false
};

const INGREDIENT_PRICES = {
    salad: 0.5,
    cheese: 0.4,
    meat: 1.3,
    bacon: 0.7
};

const changeIngredient =(state, action, amount) => {
    const newIngredient = { [action.ingredientName]: state.ingredients[action.ingredientName] + amount };
    const updatedIngredients = updateObject(state.ingredients, newIngredient);
    const updatedState = {
        ingredients: updatedIngredients,
        totalPrice: state.totalPrice + amount * INGREDIENT_PRICES[action.ingredientName],
        building: true};
    return updateObject(state, updatedState);
};

const setIngredient = (state, action) => {
    return updateObject(state, {
        ingredients: {
            salad: action.ingredients.salad,
            bacon: action.ingredients.bacon,
            cheese: action.ingredients.cheese,
            meat: action.ingredients.meat
        },
        totalPrice: 4,
        error: false,
        building: false
    });
};

const burgerBuilder = (state = initialState, action) => {

    switch (action.type) {
        case actionTypes.ADD_INGREDIENT: return changeIngredient(state, action, 1);
        case actionTypes.REMOVE_INGREDIENT: return changeIngredient(state, action, -1);
        case actionTypes.SET_INGREDIENTS: return setIngredient(state, action);
        case actionTypes.FETCH_INGREDIENTS_FAILED: return updateObject(state, { error: true });
        default: return state;
    }
};

export default burgerBuilder;
